import React from 'react'
import PropTypes from 'prop-types'

import { Box, BoxTypes } from '@/components/layout'

const Columns = ({ children, gap = 32, ...rest }) => (
  <Box gap={gap} type={BoxTypes.COLUMNS} {...rest}>{children}</Box>
)

Columns.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.number,
}

export default Columns
